import { atomWithLocalStorage } from "@/utils/jotai/atomStorage.ts";
import { atom } from "jotai";

/** Show the language selector */
export const languageEnabled_store = atomWithLocalStorage("FF_languageEnabled", undefined);

export const analyticsEnabled = true;
export const mfaDeactivateWorks = false;
export const FF_customSubnetEnabledAtom = atom(true);
